// extracted by mini-css-extract-plugin
export var dark = "InsightsVideo-module--dark--7f5b6";
export var fadeInAnimation = "InsightsVideo-module--fadeInAnimation--e5225";
export var filters = "InsightsVideo-module--filters--2d028";
export var slide = "InsightsVideo-module--slide--c9a7b";
export var slider = "InsightsVideo-module--slider--907d7";